import { constants } from '../constants'

const STORAGE = {
  PROFILE: 'profile',
  TOKEN: 'token',
  EXPIRY: 'expiry',
}

export default class Session {
  setExpiry = (force = false) => {
    let expiry = this.getExpiry()
    if (!expiry || force) {
      expiry = new Date(new Date().getTime() + constants.TIMEOUT)
      sessionStorage.setItem(STORAGE.EXPIRY, expiry.getTime().toString())
    }
  }

  getExpiry = () => {
    const data = sessionStorage.getItem(STORAGE.EXPIRY)
    if (data && data != '') {
      return new Date(parseInt(data))
    }
    return null
  }

  setProfile = (data) => {
    let profile = JSON.stringify(data)
    sessionStorage.setItem(STORAGE.PROFILE, profile)
    this.setExpiry(data)
  }

  getProfile = () => {
    let data = sessionStorage.getItem(STORAGE.PROFILE)
    let profile = JSON.parse(data)
    return { ...profile, isLoading: false }
  }

  updateSignature = (signature) => {
    var data = sessionStorage.getItem(STORAGE.PROFILE)
    var profile = JSON.parse(data)
    profile.user.signature = signature
    this.setProfile(profile)
  }

  remove = (storage) => {
    console.log('=====remove=====', storage)
    sessionStorage.removeItem(storage)
  }

  updateCustomer = (customer) => {
    var data = sessionStorage.getItem(STORAGE.PROFILE)
    var profile = JSON.parse(data)
    if (!profile) return
    profile.customer = customer
    sessionStorage.setItem(STORAGE.PROFILE, JSON.stringify(profile))
  }

  updateCompany = (company) => {
    var data = sessionStorage.getItem(STORAGE.PROFILE)
    var profile = JSON.parse(data)
    profile.company = company
    sessionStorage.setItem(STORAGE.PROFILE, JSON.stringify(profile))
  }

  removeAll = () => sessionStorage.clear()
}
